
import { defineComponent } from 'vue'

import AppResponsive from '@/components/AppResponsive.vue'

export default defineComponent({
  components: { AppResponsive },
})
